import { headerNotifications } from "../../constants/actionTypes";

const getUserNotificationListData = (data) => ({
  type: headerNotifications.USER_NOTIFICATION_LIST_GET_DATA,
  payload: data,
});

const setUserNotificationListData = (data) => ({
  type: headerNotifications.USER_NOTIFICATION_LIST_SET_DATA,
  payload: data,
});

const setUserNotificationListDataWs = (data) => ({
  type: headerNotifications.USER_NOTIFICATION_LIST_SET_DATA_WS,
  payload: data,
});

const setUserNotificationListError = (data) => ({
  type: headerNotifications.USER_NOTIFICATION_LIST_SET_ERROR,
  payload: data,
});

const userNotificationUpdateReadStatus = (id, data, markAll) => ({
  type: headerNotifications.USER_NOTIFICATION_UPDATE_READ_STATUS,
  payload: { id, data, markAll },
});

const userNotificationReadStatusSuccess = (data) => ({
  type: headerNotifications.USER_NOTIFICATION_READ_STATUS_SUCCESS,
  payload: data,
});

const userNotificationReadStatusError = (error) => ({
  type: headerNotifications.USER_NOTIFICATION_READ_STATUS_FAILURE,
  payload: error,
});

export {
  getUserNotificationListData,
  setUserNotificationListData,
  setUserNotificationListError,
  userNotificationUpdateReadStatus,
  userNotificationReadStatusSuccess,
  userNotificationReadStatusError,
  setUserNotificationListDataWs,
};
